export default __webpack_public_path__ + "4585ac0406869ec69e042acfebd9b995.glb";